/**
 * Public auth URLs. Sign in and sign up are separate paths so each can be
 * linked directly — onboarding emails, landing-page CTAs, ad campaigns — rather
 * than sharing one `/auth` page with a tab toggle.
 *
 * Change a slug here and every route, link, redirect, and password-reset email
 * follows. Anything pointing at the old combined page is handled by
 * `LegacyAuthRedirect`.
 */

export const SIGN_IN_PATH = "/login";
export const SIGN_UP_PATH = "/signup";

/** The original combined page. Still routed, permanently redirects. */
export const LEGACY_AUTH_PATH = "/auth";

export type AuthMode = "signin" | "signup";

const AUTH_PATHS: string[] = [SIGN_IN_PATH, SIGN_UP_PATH, LEGACY_AUTH_PATH];

/** True for any page that hosts the auth forms — used to gate redirects away from them. */
export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.includes(pathname);
}

export function authModeForPath(pathname: string): AuthMode {
  return pathname === SIGN_UP_PATH ? "signup" : "signin";
}

export function pathForAuthMode(mode: AuthMode): string {
  return mode === "signup" ? SIGN_UP_PATH : SIGN_IN_PATH;
}
